// Central navigation resolver so Navbar + Footer behave the same across routes.
export function resolveDest(pathname, item) {
  if (item.to) return item.to; // route (may include a hash e.g. /services#risk)
  return pathname === "/" ? item.href : `/${item.href}`; // hash section on home
}

export function goNav({ navigate, pathname, item, scrollTo }) {
  const dest = resolveDest(pathname, item);
  if (dest.startsWith("#")) {
    scrollTo(dest);
  } else {
    navigate(dest);
  }
}
